
(function () {
  if (window.__mbsCollectionProductsBound) return;
  window.__mbsCollectionProductsBound = true;
  var activeRequest = null;

  function rootFor(node) { return node && node.closest ? node.closest('[data-cp-root]') : null; }
  function positionColourPopover(picker) {
    var popover = picker.querySelector('[data-cp-colour-popover]');
    if (!popover) return;
    popover.style.setProperty('--mcp-popover-shift', '0px');
    window.requestAnimationFrame(function () {
      var rect = popover.getBoundingClientRect();
      var gutter = 16;
      var shift = 0;
      if (rect.left < gutter) shift += gutter - rect.left;
      if (rect.right + shift > window.innerWidth - gutter) shift -= rect.right + shift - (window.innerWidth - gutter);
      popover.style.setProperty('--mcp-popover-shift', shift + 'px');
    });
  }
  function setColourPicker(picker, open, forceClosed) {
    if (!picker) return;
    var trigger = picker.querySelector('[data-cp-colour-trigger]');
    picker.classList.toggle('is-open', open);
    picker.classList.toggle('is-force-closed', !!forceClosed && !open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      picker.classList.remove('is-force-closed');
      positionColourPopover(picker);
    }
  }
  function closeColourPickers(except, forceClosed) {
    document.querySelectorAll('[data-cp-colour-picker]').forEach(function (picker) {
      if (picker !== except) setColourPicker(picker, false, forceClosed);
    });
  }
  function applyColourOption(button) {
    if (!button || button.disabled) return;
    var picker = button.closest('[data-cp-colour-picker]');
    var card = button.closest('.mcp-card');
    if (!picker || !card) return;

    var label = card.querySelector('[data-cp-card-colour]');
    var image = card.querySelector('.mcp-card__image--product');
    var sku = card.querySelector('[data-cp-card-sku]');
    var price = card.querySelector('[data-cp-card-price]');
    var saving = card.querySelector('[data-cp-card-saving]');
    var sold = card.querySelector('[data-cp-card-sold]');
    var stockBadge = card.querySelector('.stock-alert-badge');
    var url = button.dataset.url;

    if (label) label.textContent = button.dataset.label;
    if (image && button.dataset.imageSrc) {
      if (button.dataset.imageSrcset) image.setAttribute('srcset', button.dataset.imageSrcset);
      image.setAttribute('src', button.dataset.imageSrc);
      image.setAttribute('alt', button.dataset.imageAlt || '');
      card.classList.add('is-colour-preview');
    }
    if (url) card.querySelectorAll('.mcp-card__image-link,.mcp-card__title a').forEach(function (link) { link.href = url; });
    var enquiry = card.querySelector('.mcp-card__enquiry .mbs-sales-cta');
    if (url && enquiry) enquiry.href = url + '#product-enquiry';
    if (sku) {
      var skuValue = sku.querySelector('span');
      if (skuValue) skuValue.textContent = button.dataset.sku || '';
      sku.hidden = !button.dataset.sku;
    }
    if (price) price.textContent = button.dataset.price || '';
    if (saving) {
      var savingValue = saving.querySelector('span');
      var compareValue = saving.querySelector('s');
      if (savingValue) savingValue.textContent = button.dataset.saving || '';
      if (compareValue) compareValue.textContent = button.dataset.compareAt || '';
      saving.hidden = button.dataset.onSale !== 'true';
    }
    if (stockBadge) stockBadge.hidden = button.dataset.available !== 'true' && !stockBadge.classList.contains('stock-alert-badge--out');
    if (sold) sold.hidden = button.dataset.available === 'true' || !!stockBadge && !stockBadge.hidden;

    picker.querySelectorAll('[data-cp-colour-option]').forEach(function (option) {
      var selected = option === button;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    setColourPicker(picker, false, true);
    var trigger = picker.querySelector('[data-cp-colour-trigger]');
    if (trigger) trigger.focus({ preventScroll: true });
  }
  function loadLifestyleImage(image) {
    var card = image.closest('.mcp-card');
    function ready() { if (card) card.classList.add('is-lifestyle-ready'); }
    if (image.complete && image.naturalWidth > 0) { ready(); return; }
    image.addEventListener('load', ready, { once: true });
    if (!image.getAttribute('src')) {
      if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
      if (image.dataset.src) image.setAttribute('src', image.dataset.src);
    }
  }
  function paintLifestyle(root) {
    var active = false;
    try { active = localStorage.getItem('mbs:collection-lifestyle:v1') === 'true'; } catch (error) {}
    if (active) root.querySelectorAll('[data-cp-lifestyle-image]').forEach(loadLifestyleImage);
    root.querySelectorAll('.mcp-card.is-colour-preview').forEach(function (card) { card.classList.remove('is-colour-preview'); });
    root.classList.toggle('is-lifestyle', active);
    root.querySelectorAll('[data-cp-lifestyle]').forEach(function (input) { input.checked = active; });
  }
  function paintFilterSelection(root) {
    var params = new URLSearchParams(window.location.search);
    root.querySelectorAll('.mcp-filter__values input[type="checkbox"][name]').forEach(function (input) {
      input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
    });
  }
  function priceLabel(value) {
    if (value >= 1000) {
      var compact = value / 1000;
      return (Math.round(compact * 10) / 10).toString().replace('.0', '') + 'K';
    }
    return Math.round(value).toString();
  }
  function paintPrice(price) {
    var max = Number(price.dataset.priceMax) || 0;
    var minInput = price.querySelector('[data-cp-price-number="min"]');
    var maxInput = price.querySelector('[data-cp-price-number="max"]');
    var minSlider = price.querySelector('[data-cp-price-slider="min"]');
    var maxSlider = price.querySelector('[data-cp-price-slider="max"]');
    var range = price.querySelector('[data-cp-price-range]');
    if (!max || !minInput || !maxInput || !minSlider || !maxSlider || !range) return;
    var minValue = Math.max(0, Math.min(Number(minSlider.value) || 0, max));
    var maxValue = Math.max(minValue, Math.min(Number(maxSlider.value) || max, max));
    minSlider.value = minValue;
    maxSlider.value = maxValue;
    minSlider.setAttribute('aria-valuetext', price.dataset.priceSymbol + priceLabel(minValue));
    maxSlider.setAttribute('aria-valuetext', price.dataset.priceSymbol + priceLabel(maxValue));
    range.style.setProperty('--mcp-price-start', (minValue / max * 100) + '%');
    range.style.setProperty('--mcp-price-end', (maxValue / max * 100) + '%');
  }
  function bootPrice(price) {
    var max = Number(price.dataset.priceMax) || 0;
    var minInput = price.querySelector('[data-cp-price-number="min"]');
    var maxInput = price.querySelector('[data-cp-price-number="max"]');
    var minSlider = price.querySelector('[data-cp-price-slider="min"]');
    var maxSlider = price.querySelector('[data-cp-price-slider="max"]');
    var range = price.querySelector('[data-cp-price-range]');
    if (!max || !minInput || !maxInput || !minSlider || !maxSlider || !range) return;
    minSlider.value = minInput.value === '' ? 0 : Math.min(Number(minInput.value) || 0, max);
    maxSlider.value = maxInput.value === '' ? max : Math.min(Number(maxInput.value) || max, max);
    range.querySelectorAll('[data-cp-price-tick]').forEach(function (tick) {
      tick.textContent = priceLabel(max * Number(tick.dataset.cpPriceTick) / 100);
    });
    range.classList.add('is-ready');
    paintPrice(price);
  }
  function boot(root) {
    if (!root) return;
    paintLifestyle(root);
    paintFilterSelection(root);
    root.querySelectorAll('[data-cp-price]').forEach(bootPrice);
  }
  function setBusy(root, busy) {
    var loading = root.querySelector('[data-cp-loading]');
    if (loading) { loading.hidden = !busy; loading.setAttribute('aria-hidden', busy ? 'false' : 'true'); }
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
  function removeEmptyParams(url) {
    var clean = new URLSearchParams();
    url.searchParams.forEach(function (value, key) {
      if (String(value).trim() !== '') clean.append(key, value);
    });
    url.search = clean.toString();
    return url;
  }
  function renderUrl(root, url, push, scrollToResults) {
    var target = removeEmptyParams(new URL(url, window.location.href));
    var cleanUrl = target.pathname + target.search + target.hash;
    target.searchParams.set('section_id', root.dataset.sectionId);
    if (activeRequest) activeRequest.abort();
    var controller = new AbortController();
    activeRequest = controller;
    setBusy(root, true);
    return fetch(target.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('Collection update failed'); return response.text(); })
      .then(function (html) {
        if (activeRequest !== controller) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cp-root]');
        if (!next) throw new Error('Collection section missing from response');
        root.replaceWith(next);
        if (push) history.pushState({ mbsCollection: true }, '', cleanUrl);
        boot(next);
        if (scrollToResults) {
          window.requestAnimationFrame(function () {
            var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            next.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          });
        }
        var results = next.querySelector('.mcp__results');
        if (results && push) results.focus({ preventScroll: true });
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        window.location.assign(cleanUrl);
      })
      .finally(function () { if (activeRequest === controller) activeRequest = null; });
  }
  function formUrl(form) {
    var url = new URL(form.action, window.location.href);
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    params.delete('page');
    url.search = params.toString();
    return url.toString();
  }

  document.addEventListener('click', function (event) {
    var colourOption = event.target.closest('[data-cp-colour-option]');
    if (colourOption) { applyColourOption(colourOption); return; }

    var colourTrigger = event.target.closest('[data-cp-colour-trigger]');
    if (colourTrigger) {
      var colourPicker = colourTrigger.closest('[data-cp-colour-picker]');
      var supportsHover = window.matchMedia && window.matchMedia('(hover:hover)').matches;
      var willOpen = supportsHover || !colourPicker.classList.contains('is-open') || colourPicker.classList.contains('is-force-closed');
      closeColourPickers(colourPicker, false);
      setColourPicker(colourPicker, willOpen, false);
      return;
    }

    closeColourPickers(null, false);
    var open = event.target.closest('[data-cp-open-filters]');
    if (open) {
      var openRoot = rootFor(open);
      var openBackdrop = openRoot.querySelector('.mcp__drawer-backdrop');
      openRoot.classList.add('is-filters-open');
      open.setAttribute('aria-expanded', 'true');
      if (openBackdrop) openBackdrop.hidden = false;
      document.body.style.overflow = 'hidden'; return;
    }
    var close = event.target.closest('[data-cp-close-filters]');
    if (close) {
      var closeRoot = rootFor(close);
      var closeOpen = closeRoot.querySelector('[data-cp-open-filters]');
      var closeBackdrop = closeRoot.querySelector('.mcp__drawer-backdrop');
      closeRoot.classList.remove('is-filters-open');
      if (closeOpen) closeOpen.setAttribute('aria-expanded', 'false');
      if (closeBackdrop) closeBackdrop.hidden = true;
      document.body.style.overflow = ''; return;
    }

    var more = event.target.closest('[data-cp-values-more]');
    if (more) {
      var list = more.previousElementSibling;
      var extras = list ? list.querySelectorAll('[data-cp-extra]') : [];
      var expanding = Array.prototype.some.call(extras, function (item) { return item.hidden; });
      extras.forEach(function (item) { item.hidden = !expanding; });
      more.textContent = expanding ? more.dataset.less : more.dataset.more;
      return;
    }

    var link = event.target.closest('a[data-cp-link]');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      var linkRoot = rootFor(link); if (!linkRoot) return;
      document.body.style.overflow = '';
      event.preventDefault(); renderUrl(linkRoot, link.href, true, !!link.closest('.mcp__pager'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowDown') {
      var colourTrigger = event.target.closest('[data-cp-colour-trigger]');
      if (colourTrigger) {
        event.preventDefault();
        var colourPicker = colourTrigger.closest('[data-cp-colour-picker]');
        setColourPicker(colourPicker, true, false);
        var firstColour = colourPicker.querySelector('[data-cp-colour-option]:not(:disabled)');
        if (firstColour) window.setTimeout(function () { firstColour.focus(); }, 0);
        return;
      }
    }
    if (event.key !== 'Escape') return;
    var openColour = event.target.closest('[data-cp-colour-picker]') || document.querySelector('[data-cp-colour-picker].is-open');
    if (openColour) {
      var colourTrigger = openColour.querySelector('[data-cp-colour-trigger]');
      setColourPicker(openColour, false, true);
      if (colourTrigger) colourTrigger.focus({ preventScroll: true });
      return;
    }
    var root = document.querySelector('[data-cp-root].is-filters-open');
    if (!root) return;
    var open = root.querySelector('[data-cp-open-filters]');
    var backdrop = root.querySelector('.mcp__drawer-backdrop');
    root.classList.remove('is-filters-open');
    if (open) { open.setAttribute('aria-expanded', 'false'); open.focus(); }
    if (backdrop) backdrop.hidden = true;
    document.body.style.overflow = '';
  });

  document.addEventListener('pointerover', function (event) {
    if (window.matchMedia && !window.matchMedia('(hover:hover)').matches) return;
    var picker = event.target.closest('[data-cp-colour-picker]');
    if (!picker || (event.relatedTarget && picker.contains(event.relatedTarget))) return;
    closeColourPickers(picker, false);
    setColourPicker(picker, true, false);
  });

  document.addEventListener('pointerout', function (event) {
    if (window.matchMedia && !window.matchMedia('(hover:hover)').matches) return;
    var picker = event.target.closest('[data-cp-colour-picker]');
    if (!picker || (event.relatedTarget && picker.contains(event.relatedTarget))) return;
    if (!picker.contains(document.activeElement)) setColourPicker(picker, false, false);
  });

  document.addEventListener('focusout', function (event) {
    var picker = event.target.closest('[data-cp-colour-picker]');
    if (!picker || (event.relatedTarget && picker.contains(event.relatedTarget))) return;
    setColourPicker(picker, false, false);
  });

  document.addEventListener('change', function (event) {
    var root = rootFor(event.target); if (!root) return;
    if (event.target.matches('[data-cp-lifestyle]')) {
      try { localStorage.setItem('mbs:collection-lifestyle:v1', event.target.checked ? 'true' : 'false'); } catch (error) {}
      paintLifestyle(root); return;
    }
    if (event.target.matches('[data-cp-mobile-sort]')) {
      var sortUrl = new URL(window.location.href);
      sortUrl.searchParams.set('sort_by', event.target.value);
      sortUrl.searchParams.delete('page');
      renderUrl(root, sortUrl.toString(), true); return;
    }
    var mobileTools = root.querySelector('.mcp__mobile-tools');
    var desktopFilters = !mobileTools || window.getComputedStyle(mobileTools).display === 'none';
    if (event.target.closest('[data-cp-form]') && desktopFilters) {
      renderUrl(root, formUrl(event.target.closest('form')), true);
    }
  });

  document.addEventListener('input', function (event) {
    var price = event.target.closest('[data-cp-price]');
    if (!price) return;
    var max = Number(price.dataset.priceMax) || 0;
    var minInput = price.querySelector('[data-cp-price-number="min"]');
    var maxInput = price.querySelector('[data-cp-price-number="max"]');
    var minSlider = price.querySelector('[data-cp-price-slider="min"]');
    var maxSlider = price.querySelector('[data-cp-price-slider="max"]');
    if (!max || !minInput || !maxInput || !minSlider || !maxSlider) return;

    if (event.target.matches('[data-cp-price-slider]')) {
      var minValue = Number(minSlider.value) || 0;
      var maxValue = Number(maxSlider.value) || max;
      if (event.target.dataset.cpPriceSlider === 'min' && minValue > maxValue) minSlider.value = maxValue;
      if (event.target.dataset.cpPriceSlider === 'max' && maxValue < minValue) maxSlider.value = minValue;
      minInput.value = Number(minSlider.value) <= 0 ? '' : minSlider.value;
      maxInput.value = Number(maxSlider.value) >= max ? '' : maxSlider.value;
    } else if (event.target.matches('[data-cp-price-number]')) {
      if (event.target.value !== '') {
        var typedPrice = Number(event.target.value.replace(/[^0-9.]/g, ''));
        event.target.value = Number.isFinite(typedPrice) ? String(Math.floor(typedPrice)) : '';
      }
      var enteredMin = minInput.value === '' ? 0 : Math.max(0, Math.min(Number(minInput.value) || 0, max));
      var enteredMax = maxInput.value === '' ? max : Math.max(0, Math.min(Number(maxInput.value) || max, max));
      if (event.target.dataset.cpPriceNumber === 'min' && enteredMin > enteredMax) enteredMin = enteredMax;
      if (event.target.dataset.cpPriceNumber === 'max' && enteredMax < enteredMin) enteredMax = enteredMin;
      if (minInput.value !== '' && Number(minInput.value) !== enteredMin) minInput.value = enteredMin;
      if (maxInput.value !== '' && Number(maxInput.value) !== enteredMax) maxInput.value = enteredMax;
      minSlider.value = enteredMin;
      maxSlider.value = enteredMax;
    }
    paintPrice(price);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cp-form]'); if (!form) return;
    var root = rootFor(form); event.preventDefault(); document.body.style.overflow = ''; renderUrl(root, formUrl(form), true);
  });

  window.addEventListener('popstate', function () {
    var root = document.querySelector('[data-cp-root]'); if (root) renderUrl(root, window.location.href, false);
  });
  document.addEventListener('shopify:section:load', function (event) { boot(event.target.querySelector('[data-cp-root]')); });
  document.querySelectorAll('[data-cp-root]').forEach(boot);
})();
